<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline">
                <h2 class="tit">캐시선물하기</h2>
            </div>

            <v-divider class="d-md-none" />
            <div class="py-20px pt-md-0px pb-md-40px text-center">
                <div class="tit tit--xs"><b class="black--text">{{ me?.name }}</b>님의 나누리 캐시</div>
                <div class="mt-1"><b class="tit tit--lg primary--text font-weight-bold">{{ parseInt(+me?.cash || 0 ).format() }}</b> 원</div>
            </div>
            <v-divider />

            <div class="pt-20px pt-md-30px">
                <v-responsive width="100%" max-width="400" class="mx-auto">
                    <v-row>
                        <v-col cols="12">
                            <div class="mb-10px"><b>보내는 금액</b></div>
                            <v-text-field v-model="gift.amount" placeholder="보내는 금액" persistent-placeholder suffix="원" outlined hide-details class="w-100" @input="comma(gift.amount)"/>
                        </v-col>
                        <v-col cols="12">
                            <v-row class="row--x-small">
                                <v-col cols="auto">
                                    <b>받는사람정보</b>
                                </v-col>
                                <v-spacer></v-spacer>
                                <!-- <v-col cols="auto">
                                    <v-btn small outlined color="primary" @click="$refs.memberDialog.open()">회원검색</v-btn>
                                </v-col> -->
                            </v-row>
                            <v-row class="row--medium mt-6px">
                                <!-- <v-col cols="12">
                                    <v-text-field :value="gift.receiver.name" label="이름" persistent-placeholder outlined hide-details readonly/>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field :value="gift.receiver.username" label="아이디" persistent-placeholder outlined hide-details readonly/>
                                </v-col> -->
                                <v-col cols="12">
                                    <v-text-field v-model="gift.receiver.phone" label="연락처" persistent-placeholder outlined hide-details/>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn color="secondary" x-large block @click="give">캐시선물하기</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-responsive>
            </div>
        </div>

        <member-dialog ref="memberDialog" :me="me" @input="member => gift.receiver = member"></member-dialog>
        <give-dialog ref="giveDialog" @init="member => recentUserFilter(member)" v-model="gift"></give-dialog>
        <login-dialog ref="loginDialog" />
        <kcb-cert ref="kcbCert" />
    </component>
</template>
<script>
import api from "@/api";
import { mdiAccountSearchOutline, mdiGiftOutline } from "@mdi/js";
import MemberDialog from "@/components/client/member/member-dialog.vue";
import GiveDialog from "@/components/client/give/give-dialog.vue"
import KcbCert from "@/components/plugins/kcb/kcb-cert.vue";
import LoginDialog from "@/components/client/login/login-dialog.vue";
export default {
    components: {
        MemberDialog,
        GiveDialog,
        KcbCert,
        LoginDialog
    },
    data(){
        return {
            mdiGiftOutline,
            mdiAccountSearchOutline,

            me: null,

            gift: {
                receiver: {
                    _id: null,
                    name: null,
                    username: null,
                    phone: null
                },

                amount: 0
            }
        }
    },
    mounted(){
        if(this.logoff){
            this.$router.push(`/login`);
            return;
        }

        this.init();
    },
    methods: {
        async init(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;
            // this.me.recentUser = this.me.recentUser.filter(el => {
            //     return el.isBlock !== true && el.isWithdrawal !== true
            // })
        },
        // 로컬 테스트용
        // async getAccessToken(){
        //     await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert: "622af4183dae29e48d8a3e08" });
        //     alert(this.$store.state.payload);
        //     alert(this.$store.state.scope);
        // },
        certificate(){
            return new Promise((resolve, reject) => {
                if(this.scope?.includes?.("cert")) resolve();
                else {
                    this.$refs.kcbCert.$off();
                    this.$refs.kcbCert.$on("input", async ({ _cert }) => {
                        console.log(_cert)
                        await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert });
                        resolve();
                    });

                    this.$refs.kcbCert.open();
                }
            });
        },
        give(){
            const regex = /^010-\d{4}-\d{4}$/;
            if (!this.gift.amount) return alert('보내는 금액을 설정해주세요')
            if (this.gift.amount < 1000) return alert("1,000원 이상부터 선물하실 수 있습니다")
            if (!this.gift.receiver.phone) return alert('보낼 연락처를 입력해주세요')
            if (!regex.test(this.gift.receiver.phone)) return alert("연락처를 확인해주세요")
            this.login().then(this.certificate).then(async _ => {
                this.$refs.giveDialog.open()
            });
        },
        login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else{
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("cancel", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },
        recentUserFilter(me){
            this.me = me;
            this.me.recentUser = me.recentUser.filter(el => {
                return el.isBlock !== true && el.isWithdrawal !== true && el.isAutoBlock == true
            })
        },
        comma(amount) {
            this.gift.amount = String(amount).replace(/[^0-9]/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    computed: {
        refreshToken(){ return this.$store.state.refreshToken },
        accessToken(){ return this.$store.state.accessToken },
        logoff(){ return !this.accessToken },
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`); },
        scope(){ return this.$store.state.scope },
        logon(){ return !!this.accessToken },
    },
    watch: {
        "gift.receiver.phone"() {
            let cleanedNumber = this.gift.receiver.phone.replace(/[^0-9-]/g, '');
            let digits = cleanedNumber.match(/\d/g);
            let formattedNumber = digits.join('');

            this.gift.receiver.phone = formattedNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
        },
    }
}
</script>

<style scoped>
</style>